import React from "react";

interface MaskedSecretProps {
  prefix: string;
  maskLength?: number;
  className?: string;
}

export function MaskedSecret({
  prefix,
  maskLength = 14,
  className,
}: MaskedSecretProps) {
  return (
    <code className={["font-mono text-xs", className].filter(Boolean).join(" ")}>
      {prefix}
      <span className="text-muted">{"*".repeat(maskLength)}</span>
    </code>
  );
}
